export default __webpack_public_path__ + "static/media/marketing_1.f35520b9.svg";